import styled from 'styled-components';

export const Title = styled.span`
  text-align: center;
  font-size: 0.875rem;
  font-size: clamp(0.875rem, 0.645rem + 0.4vw, 1.125rem);
  font-weight: 500;
  color: ${p => p.theme.palette.neutralPrimaryAlt};
`;

export const IconContainer = styled(Title)`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  border-radius: 0.25rem;
  cursor: pointer;

  :hover {
    color: ${p => p.theme.palette.themePrimary};
    background-color: ${p => p.theme.palette.neutralLighter};
  }
`;

export const CardHeader = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  & > :first-child {
    width: 100%;
  }

  .extras-button {
    position: absolute;
    right: 0;
  }
`;